"use client";
import React from "react";
import styled from "styled-components";
import { send } from "../../assets/images";

function ChatInterface() {
  const chatMessages = [
    {
      type: "bot",
      content: {
        greeting: "Hi there! My name is Raven!",
        message: "I'm here to help answer your questions. How can I assist you today?"
      }
    }
  ];

  const suggestedQuestions = [
    {
      icon: (
        <svg width="38" height="39" viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.0373688" y="0.455566" width="37.757" height="37.757" rx="18.8785" fill="white"/>
          <path d="M11.2728 28.7733C10.7709 28.7733 10.346 28.5995 9.99827 28.2517C9.6505 27.9039 9.47662 27.4791 9.47662 26.9772V16.6591C9.47662 16.1571 9.6505 15.7323 9.99827 15.3845C10.346 15.0367 10.7709 14.8629 11.2728 14.8629H16.4319V11.3852C16.4319 10.9726 16.5771 10.621 16.8676 10.3305C17.158 10.0401 17.5096 9.89484 17.9223 9.89484H19.9095C20.3222 9.89484 20.6737 10.0401 20.9642 10.3305C21.2547 10.621 21.3999 10.9726 21.3999 11.3852V14.8629H26.5589C27.0609 14.8629 27.4857 15.0367 27.8335 15.3845C28.1812 15.7323 28.3551 16.1571 28.3551 16.6591V26.9772C28.3551 27.4791 28.1812 27.9039 27.8335 28.2517C27.4857 28.5995 27.0609 28.7733 26.5589 28.7733H11.2728ZM11.2728 27.2829H26.5589C26.6482 27.2829 26.7215 27.2543 26.7788 27.197C26.8361 27.1397 26.8647 27.0664 26.8647 26.9772V16.6591C26.8647 16.5698 26.8361 16.4965 26.7788 16.4392C26.7215 16.3819 26.6482 16.3533 26.5589 16.3533H21.3999V16.7356C21.3999 17.1418 21.2531 17.4917 20.9595 17.7853C20.6659 18.0789 20.3159 18.2257 19.9095 18.2257H17.9223C17.5159 18.2257 17.1659 18.0789 16.8723 17.7853C16.5787 17.4917 16.4319 17.1418 16.4319 16.7356V16.3533H11.2728C11.1836 16.3533 11.1103 16.3819 11.053 16.4392C10.9957 16.4965 10.967 16.5698 10.967 16.6591V26.9772C10.967 27.0664 10.9957 27.1397 11.053 27.197C11.1103 27.2543 11.1836 27.2829 11.2728 27.2829ZM13.107 25.0091H18.7631V24.7147C18.7631 24.4587 18.6924 24.2234 18.551 24.0088C18.4096 23.7941 18.214 23.627 17.9643 23.5072C17.6395 23.3645 17.3105 23.2575 16.9774 23.1863C16.6443 23.1149 16.2969 23.0792 15.9351 23.0792C15.5732 23.0792 15.2258 23.1149 14.8928 23.1863C14.5596 23.2575 14.2306 23.3645 13.9059 23.5072C13.6561 23.627 13.4606 23.7941 13.3191 24.0088C13.1777 24.2234 13.107 24.4587 13.107 24.7147V25.0091ZM20.9031 23.4995H24.8775V22.3149H20.9031V23.4995ZM15.9351 22.3149C16.3045 22.3149 16.6198 22.1843 16.881 21.9232C17.1421 21.662 17.2727 21.3467 17.2727 20.9773C17.2727 20.608 17.1421 20.2928 16.881 20.0316C16.6198 19.7704 16.3045 19.6399 15.9351 19.6399C15.5656 19.6399 15.2503 19.7704 14.9891 20.0316C14.728 20.2928 14.5974 20.608 14.5974 20.9773C14.5974 21.3467 14.728 21.662 14.9891 21.9232C15.2503 22.1843 15.5656 22.3149 15.9351 22.3149ZM20.9031 20.8245H24.8775V19.6399H20.9031V20.8245ZM17.9223 16.7356H19.9095V11.3852H17.9223V16.7356Z" fill="#D92128"/>
        </svg>
      ),
      text: "What are the degree and certificate programs offered at CMN?"
    },
    {
      icon: (
        <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.03261 15.7155V1.94992V6.20815V5.69391V15.7155ZM4.24493 9.57015H9.4316C9.45815 9.30418 9.51649 9.04829 9.60662 8.80247C9.69659 8.55666 9.80844 8.32092 9.94216 8.09527H4.24493V9.57015ZM4.24493 13.5032H7.88666C8.10855 13.251 8.35568 13.0383 8.62804 12.865C8.90024 12.6917 9.18571 12.5489 9.48445 12.4368C9.44414 12.3762 9.40882 12.3106 9.37851 12.2402C9.34835 12.1695 9.3232 12.0989 9.30304 12.0283H4.24493V13.5032ZM4.24493 5.63713H13.5859V4.16224H4.24493V5.63713ZM2.3352 17.1904C1.8385 17.1904 1.41807 17.0183 1.07393 16.6742C0.729794 16.33 0.557724 15.9096 0.557724 15.4129V2.25252C0.557724 1.75581 0.729794 1.33539 1.07393 0.991246C1.41807 0.647106 1.8385 0.475037 2.3352 0.475037H15.4956C15.9923 0.475037 16.4127 0.647106 16.7569 0.991246C17.101 1.33539 17.2731 1.75581 17.2731 2.25252V7.59233C17.0877 7.29227 16.8737 7.02721 16.631 6.79712C16.3885 6.56704 16.1109 6.37072 15.7982 6.20815V2.25252C15.7982 2.17681 15.7666 2.10749 15.7035 2.04456C15.6406 1.98147 15.5713 1.94992 15.4956 1.94992H2.3352C2.25949 1.94992 2.19017 1.98147 2.12725 2.04456C2.06415 2.10749 2.03261 2.17681 2.03261 2.25252V15.4129C2.03261 15.4886 2.06415 15.5579 2.12725 15.6209C2.19017 15.684 2.25949 15.7155 2.3352 15.7155H6.97912C6.96912 15.776 6.96158 15.8364 6.9565 15.8969C6.95142 15.9575 6.94888 16.0181 6.94888 16.0786V17.1904H2.3352ZM13.7749 12.2741C13.1623 12.2741 12.6405 12.0585 12.2093 11.6274C11.7781 11.1962 11.5626 10.6743 11.5626 10.0618C11.5626 9.44905 11.7781 8.92718 12.2093 8.49619C12.6405 8.06503 13.1623 7.84945 13.7749 7.84945C14.3876 7.84945 14.9095 8.06503 15.3405 8.49619C15.7716 8.92718 15.9872 9.44905 15.9872 10.0618C15.9872 10.6743 15.7716 11.1962 15.3405 11.6274C14.9095 12.0585 14.3876 12.2741 13.7749 12.2741ZM9.10443 17.1904V16.0596C9.10443 15.7104 9.19423 15.3899 9.37384 15.098C9.55361 14.8063 9.80672 14.5961 10.1332 14.4675C10.7041 14.2281 11.2956 14.0485 11.9077 13.9287C12.5198 13.8089 13.1422 13.749 13.7749 13.749C14.3952 13.749 15.0113 13.8089 15.6232 13.9287C16.2352 14.0485 16.8331 14.2281 17.4169 14.4675C17.7433 14.5961 17.9963 14.8063 18.1759 15.098C18.3555 15.3899 18.4454 15.7104 18.4454 16.0596V17.1904H9.10443Z" fill="#D92128"/>
        </svg>
      ),
      text: "What are the admission requirements for the degree programs at CMN?"
    },
    {
      icon: (
        <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.9157 16.0441L3.52454 12.5725V7.24031L0.121002 5.37974L9.9157 0.0475464L19.7104 5.37974V12.4516H18.2355V6.19658L16.3069 7.24031V12.5725L9.9157 16.0441ZM9.9157 9.01779L16.6417 5.37974L9.9157 1.74169L3.18974 5.37974L9.9157 9.01779ZM9.9157 14.3652L14.832 11.7104V8.02691L9.9157 10.7102L4.99942 8.02691V11.7104L9.9157 14.3652Z" fill="#D92128"/>
        </svg>
      ),
      text: "What exceptions are there for providing proof of academic proficiency for concurrent enrollment?"
    },
    {
      icon: (
        <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.92825 21.218C8.17442 21.218 7.5063 21.0056 6.92388 20.5809C6.34163 20.1561 5.91498 19.5933 5.64393 18.8924C5.41319 19.2301 5.1097 19.4901 4.73344 19.6723C4.35718 19.8544 3.96543 19.9454 3.5582 19.9454C2.79814 19.9454 2.15747 19.6826 1.63618 19.1569C1.11489 18.6311 0.854248 17.9927 0.854248 17.2415C0.854248 16.5873 1.07425 15.9949 1.51426 15.4642C1.9541 14.9334 2.51062 14.646 3.18383 14.6019C2.90393 14.2868 2.68523 13.9307 2.52775 13.5336C2.3701 13.1365 2.29128 12.7205 2.29128 12.2856C2.29128 11.6852 2.44196 11.1222 2.74333 10.5966C3.04453 10.0712 3.46684 9.64091 4.01025 9.30562C4.07351 9.52554 4.15897 9.76078 4.26664 10.0113C4.3743 10.2619 4.49303 10.4818 4.62282 10.6709C4.35554 10.8764 4.15004 11.1223 4.00632 11.4088C3.8626 11.6954 3.79074 11.9959 3.79074 12.3102C3.79074 13.2784 4.16766 13.8895 4.92148 14.1435C5.67531 14.3975 6.41972 14.5964 7.1547 14.7401L7.49884 15.3281C7.31858 15.8525 7.16757 16.2975 7.04581 16.6631C6.92421 17.0285 6.86341 17.3619 6.86341 17.6633C6.86341 18.2154 7.06252 18.6985 7.46074 19.1126C7.8588 19.5267 8.34485 19.7338 8.91891 19.7338C9.57949 19.7338 10.1241 19.4631 10.5526 18.9216C10.9811 18.3802 11.3328 17.7405 11.6076 17.0025C11.8824 16.2644 12.0943 15.5118 12.2431 14.7447C12.3918 13.9776 12.5135 13.3703 12.6081 12.9228L14.0525 13.3161C13.9114 14.0094 13.7406 14.8093 13.5402 15.7157C13.3398 16.6221 13.0564 17.4834 12.6902 18.2995C12.3239 19.1157 11.842 19.8062 11.2446 20.3709C10.6471 20.9356 9.87496 21.218 8.92825 21.218ZM3.5582 18.4708C3.89988 18.4708 4.19019 18.3513 4.42912 18.1124C4.66789 17.8735 4.78727 17.5832 4.78727 17.2415C4.78727 16.9 4.66789 16.6097 4.42912 16.3708C4.19019 16.1319 3.89988 16.0124 3.5582 16.0124C3.21668 16.0124 2.92646 16.1319 2.68753 16.3708C2.4486 16.6097 2.32913 16.9 2.32913 17.2415C2.32913 17.5832 2.4486 17.8735 2.68753 18.1124C2.92646 18.3513 3.21668 18.4708 3.5582 18.4708ZM10.0383 14.5016C9.3286 13.8676 8.68219 13.2754 8.09912 12.7251C7.51605 12.175 7.01361 11.6381 6.59179 11.1143C6.16981 10.5906 5.8455 10.0667 5.61886 9.54283C5.39222 9.01908 5.2789 8.47485 5.2789 7.91013C5.2789 6.91409 5.61984 6.07513 6.30173 5.39324C6.98362 4.71136 7.82258 4.37041 8.81862 4.37041C8.94087 4.37041 9.05026 4.37771 9.14678 4.39229C9.24314 4.40671 9.33982 4.42334 9.43684 4.44219C9.36506 4.28471 9.30967 4.12501 9.27067 3.9631C9.2315 3.80135 9.21192 3.63141 9.21192 3.45328C9.21192 2.70224 9.47469 2.06386 10.0002 1.53815C10.5258 1.01227 11.1639 0.749329 11.9146 0.749329C12.6655 0.749329 13.3041 1.01227 13.8303 1.53815C14.3566 2.06386 14.6198 2.70224 14.6198 3.45328C14.6198 3.63354 14.6002 3.80152 14.5611 3.9572C14.5221 4.11288 14.4667 4.26955 14.3949 4.4272C14.4919 4.40835 14.5886 4.39417 14.685 4.38467C14.7815 4.37517 14.8909 4.37041 15.0131 4.37041C15.8766 4.37041 16.6194 4.63384 17.2414 5.1607C17.8635 5.68773 18.259 6.34897 18.428 7.14442C18.2033 7.10788 17.9505 7.08961 17.6696 7.08961C17.3886 7.08961 17.1302 7.1028 16.8946 7.12918C16.7484 6.75227 16.5095 6.4441 16.1778 6.20468C15.8463 5.96509 15.4594 5.8453 15.0173 5.8453C14.4221 5.8453 13.9537 6.00852 13.612 6.33496C13.2703 6.66156 12.8146 7.15385 12.2448 7.81181H11.5624C10.9762 7.1273 10.5123 6.62846 10.1706 6.31529C9.82891 6.00196 9.37825 5.8453 8.81862 5.8453C8.22342 5.8453 7.73048 6.04064 7.3398 6.43132C6.94912 6.822 6.75378 7.31494 6.75378 7.91013C6.75378 8.28901 6.85555 8.68027 7.05908 9.08389C7.26278 9.48768 7.55194 9.91491 7.92656 10.3656C8.30134 10.8162 8.75577 11.2956 9.28984 11.8036C9.82408 12.3116 10.4239 12.8606 11.0894 13.4505L10.0383 14.5016ZM11.9159 4.68235C12.2576 4.68235 12.5478 4.56297 12.7865 4.3242C13.0255 4.08527 13.1449 3.79496 13.1449 3.45328C13.1449 3.11176 13.0255 2.82154 12.7865 2.58261C12.5478 2.34368 12.2576 2.22421 11.9159 2.22421C11.5742 2.22421 11.284 2.34368 11.0452 2.58261C10.8063 2.82154 10.6868 3.11176 10.6868 3.45328C10.6868 3.79496 10.8063 4.08527 11.0452 4.3242C11.284 4.56297 11.5742 4.68235 11.9159 4.68235ZM14.86 21.2276C14.563 21.2276 14.2695 21.1906 13.9795 21.1165C13.6893 21.0422 13.4092 20.9248 13.1393 20.7642C13.275 20.5907 13.4107 20.3861 13.5464 20.1504C13.682 19.9148 13.8054 19.6977 13.9163 19.4993C14.0794 19.5869 14.2423 19.6495 14.4052 19.6871C14.5681 19.7246 14.731 19.7434 14.8939 19.7434C15.475 19.7434 15.967 19.5366 16.3698 19.1229C16.7726 18.7095 16.974 18.2178 16.974 17.648C16.974 17.3387 16.9132 17.0048 16.7916 16.6464C16.6698 16.2881 16.5188 15.8468 16.3386 15.3224L16.6923 14.7344C17.4435 14.5907 18.1919 14.3902 18.9375 14.1329C19.6832 13.8758 20.056 13.2631 20.056 12.295C20.056 11.5701 19.7954 11.0382 19.2743 10.6991C18.753 10.3601 18.174 10.1905 17.5374 10.1905C16.8629 10.1905 16.0759 10.3121 15.1766 10.5553C14.2772 10.7987 13.232 11.1189 12.0407 11.516L11.6474 10.0713C12.85 9.68687 13.9266 9.36166 14.8774 9.09569C15.8281 8.82972 16.7009 8.69674 17.4958 8.69674C18.5573 8.69674 19.4951 9.01064 20.3094 9.63845C21.1237 10.2663 21.5309 11.1518 21.5309 12.295C21.5309 12.7273 21.4537 13.1379 21.2993 13.5267C21.145 13.9158 20.9278 14.2742 20.6479 14.6019C21.3211 14.6524 21.8776 14.9398 22.3175 15.4642C22.7575 15.9886 22.9775 16.5811 22.9775 17.2415C22.9775 17.9853 22.7169 18.622 22.1956 19.1514C21.6743 19.6808 21.0336 19.9454 20.2735 19.9454C19.8663 19.9454 19.4746 19.8544 19.0983 19.6723C18.722 19.4901 18.4186 19.2301 18.1878 18.8924C17.9168 19.5933 17.4869 20.1576 16.8983 20.5855C16.3096 21.0136 15.6302 21.2276 14.86 21.2276ZM20.2981 18.4708C20.6396 18.4708 20.9258 18.3513 21.1565 18.1124C21.3872 17.8735 21.5026 17.5832 21.5026 17.2415C21.5026 16.9 21.3831 16.6056 21.1442 16.3585C20.9053 16.1114 20.6151 15.9878 20.2735 15.9878C19.9319 15.9878 19.6416 16.1073 19.4026 16.3462C19.1639 16.5851 19.0445 16.8754 19.0445 17.2169C19.0445 17.5586 19.168 17.853 19.4149 18.1001C19.662 18.3472 19.9564 18.4708 20.2981 18.4708Z" fill="#D92128"/>
        </svg>
      ),
      text: "How can alumni stay connected with CMN and participate in engagement opportunities?"
    },
    {
      icon: (
        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.88347 16.0876L4.73336 12.9375L5.7997 11.8712L7.88347 13.9549L12.0321 9.80634L13.0984 10.8727L7.88347 16.0876ZM2.33569 19.5443C1.83898 19.5443 1.41856 19.3722 1.07442 19.028C0.730282 18.6839 0.558212 18.2635 0.558212 17.7668V4.60639C0.558212 4.10969 0.730282 3.68926 1.07442 3.34512C1.41856 3.00098 1.83898 2.82892 2.33569 2.82892H3.69701V0.749084H5.20975V2.82892H12.6599V0.749084H14.1348V2.82892H15.4961C15.9928 2.82892 16.4132 3.00098 16.7573 3.34512C17.1015 3.68926 17.2736 4.10969 17.2736 4.60639V17.7668C17.2736 18.2635 17.1015 18.6839 16.7573 19.028C16.4132 19.3722 15.9928 19.5443 15.4961 19.5443H2.33569ZM2.33569 18.0694H15.4961C15.5718 18.0694 15.6411 18.0378 15.704 17.9747C15.7671 17.9118 15.7987 17.8425 15.7987 17.7668V8.53942H2.0331V17.7668C2.0331 17.8425 2.06464 17.9118 2.12773 17.9747C2.19066 18.0378 2.25998 18.0694 2.33569 18.0694ZM2.0331 7.06453H15.7987V4.60639C15.7987 4.53068 15.7671 4.46136 15.704 4.39844C15.6411 4.33534 15.5718 4.3038 15.4961 4.3038H2.33569C2.25998 4.3038 2.19066 4.33534 2.12773 4.39844C2.06464 4.46136 2.0331 4.53068 2.0331 4.60639V7.06453Z" fill="#D92128"/>
        </svg>
      ),
      text: "What Events are upcoming on the CMN Calendar?"
    }
  ];

  return (
    <ChatContainer>
     <HeaderContainer>
      <HeaderContent>
        <BrandingSection>
          <TitleSection>
            <AppTitle>Ask Raven</AppTitle>
            <PoweredBySection>
              <PoweredByText>Powered by</PoweredByText>
              <BrandContainer>
                <BrandName>Campus Insights</BrandName>
              </BrandContainer>
            </PoweredBySection>
          </TitleSection>
        </BrandingSection>
        <ControlsSection>
          <ExpandIcon>
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.66797 20.9266V13.5522H5.14285V18.4249L17.8817 5.68613H13.0089V4.21124H20.3833V11.5857H18.9084V6.71289L6.16962 19.4517H11.0424V20.9266H3.66797Z" fill="white"/>
            </svg>
          </ExpandIcon>
          <CloseIcon>
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.2764 19.4517L5.89984 18.0751L11.4061 12.5689L5.89984 7.06268L7.2764 5.68613L12.7826 11.1924L18.2889 5.68613L19.6654 7.06268L14.1592 12.5689L19.6654 18.0751L18.2889 19.4517L12.7826 13.9455L7.2764 19.4517Z" fill="white"/>
            </svg>
          </CloseIcon>
        </ControlsSection>
      </HeaderContent>
    </HeaderContainer>
      <ChatScrollArea>
        {chatMessages.map((message, index) => (
          <ChatMessage key={index} message={message} />
        ))}
        <SuggestedQuestions>
          {suggestedQuestions.map((question, index) => (
            <QuestionButton key={index}>
              <QuestionIcon>{question.icon}</QuestionIcon>
              <QuestionText>{question.text}</QuestionText>
            </QuestionButton>
          ))}
        </SuggestedQuestions>
      </ChatScrollArea>
     <FooterContainer>
      <FooterContent>
        <InputContainer>
         <MessageInput placeholder="Type your message here" disabled />

         {/* Usage */}
<SendButton>
  <SendIcon src={send} alt="Send" />
</SendButton>
            
         
        </InputContainer>
        <DisclaimerText>
          Responses are informational only. Verify important information independently.
        </DisclaimerText>
      </FooterContent>
    </FooterContainer>
    </ChatContainer>
  );
}

function ChatMessage({ message }) {
  if (message.type === "bot") {
    return (
      <MessageContainer>
        <BotMessage>
          <Greeting>{message.content.greeting}</Greeting>
          <MessageText>{message.content.message}</MessageText>
        </BotMessage>
      </MessageContainer>
    );
  }

  return null;
}

const MessageContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 11.799px;
  align-self: stretch;
`;

const BotMessage = styled.div`
  width: 426px;
  color: #333;
  font: 500 17px/24px Lato, -apple-system, Roboto, Helvetica, sans-serif;
`;

const Greeting = styled.div`
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 4px;
  font-family:Inter, sans-serif;
`;

const MessageText = styled.div`
  font-weight: 400;
  font-size: 17px;
  font-family:Inter, sans-serif;
`;

const ChatContainer = styled.div`
  display: flex;
  width: 505px;
  height: 668px;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  border-radius: 23.598px;
  box-shadow: 0 11.799px 18.879px 0 rgba(0, 0, 0, 0.1);
  background-color: #fcedee;
  @media (max-width: 991px) {
    width: 100%;
    max-width: 505px;
  }
  @media (max-width: 640px) {
    height: auto;
    min-height: 500px;
  }
`;

const ChatScrollArea = styled.div`
  display: flex;
  padding: 18.879px 14.159px;
  flex-direction: column;
  align-items: center;
  gap: 18.879px;
  align-self: stretch;
  flex: 1;
  background-color: #fff;
`;

const SuggestedQuestions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10.619px;
`;

const QuestionButton = styled.button`
  display: flex;
  width: 467px;
  padding: 9.439px 14.159px;
  align-items: center;
  gap: 14.159px;
  border-radius: 11.799px;
  background-color: #fcedee;
  border: none;
  cursor: pointer;
  @media (max-width: 640px) {
    width: 100%;
    padding: 12px;
  }
`;

const QuestionIcon = styled.div`
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 50%;
`;

const QuestionText = styled.span`
  flex: 1 0 0;
  color: #d92128;
  font: 400 15px/24px Lato, -apple-system, Roboto, Helvetica, sans-serif;
  text-align: left;
  @media (max-width: 640px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

const HeaderContainer = styled.header`
  display: flex;
  padding: 14.159px 18.879px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 23.598px 23.598px 0 0;
  background: linear-gradient(180deg, #b81d22 0%, #d92128 100%);
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const BrandingSection = styled.div`
  display: flex;
  align-items: center;
  gap: 14.159px;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: -1.18px;
`;

const AppTitle = styled.h1`
  color: #fff;
  font: 700 21px Inter, sans-serif;
  margin: 0;
`;

const PoweredBySection = styled.div`
  display: flex;
  align-items: center;
  gap: 4.72px;
`;

const PoweredByText = styled.span`
  color: #fff;
  text-align: center;
  letter-spacing: 0.085px;
  font: 700 14px/19px Inter, sans-serif;
`;

const BrandContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 9.439px;
`;

const BrandName = styled.span`
  color: #fff;
  text-align: center;
  letter-spacing: 0.51px;
  text-decoration-line: underline;
  font: 700 14px/19px Inter, sans-serif;
`;

const ControlsSection = styled.div`
  display: flex;
  width: 65px;
  align-items: center;
  gap: 14.159px;
`;

const ExpandIcon = styled.button`
  width: 35px;
  height: 35px;
  flex-shrink: 0;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CloseIcon = styled.button`
  width: 35px;
  height: 35px;
  flex-shrink: 0;
  background: none;
  border: none;
  cursor: pointer;
  margin-right:5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FooterContainer = styled.footer`
  display: flex;
  padding: 14.159px 18.879px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 0 0 23.598px 23.598px;
  box-shadow: 0 2.36px 11.799px 0 rgba(0, 0, 0, 0.13);
  background-color: #fff;
`;

const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7.079px;
`;

const InputContainer = styled.div`
  display: flex;
  width: 450px;
  height: 32px;
  padding: 9.439px;
  align-items: center;
  gap: 14.159px;
  border-radius: 7.079px;
  background-color: #f5f5f5;
  @media (max-width: 640px) {
    width: 100%;
  }
`;

const MessageInput = styled.input`
  flex: 1 0 0;
  color: rgba(51, 51, 51, 0.8);
  font: 400 14px/28px Lato, -apple-system, Roboto, Helvetica, sans-serif;
  background: none;
  border: none;
  outline: none;

  &::placeholder {
    color: rgba(51, 51, 51, 0.8);
  }
`;

const SendButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 33px;
  height: 33px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
`;

const SendIcon = styled.img`
  width: 100%;
  height: 100%;
`;




const DisclaimerText = styled.p`
  align-self: stretch;
  color: #6f6f6f;
  text-align: center;
  letter-spacing: 0.078px;
  font: italic 400 13px/19px Lato, -apple-system, Roboto, Helvetica, sans-serif;
  margin: 0;
`;



export default ChatInterface;
